import { Box } from '@inlight-media/linfox-ui-library';
import styled from 'styled-components';

const DottedDivider = styled(Box)`
  border: 1px dashed ${({ theme }) => theme.colors.greyThree};
`;

export { DottedDivider };
